import { createAsyncThunk, createSlice, isAnyOf } from "@reduxjs/toolkit";
import { ADMIN_API_ENDPOINTS } from "service/apiUrl";
import { API } from "service/Interceptor";

const initialState = {
  payments: [],
  filters: {
    fromDate: "",
    toDate: "",
    paymentStatus: "",
    refund: "",
    amount: "",
  },
  totalCount: null,
  isPaymentsLoading: false,
  isExporting: false,
  hasError: false,
};

export const getAllPayments = createAsyncThunk(
  "get-all-payments",
  async ({ pageSelected, search, filters }) => {
    try {
      const { fromDate, toDate, paymentStatus, refund,  amount} = filters || {};

      const queryParams = new URLSearchParams({
        search: search || "",
        export: "false",
        pageNo: pageSelected,
        perPage: 10,
      });

      if (fromDate) queryParams.append("fromDate", fromDate);
      if (toDate) queryParams.append("toDate", toDate);
      if (paymentStatus) queryParams.append("paymentStatus", paymentStatus);
      if (refund) queryParams.append("refund", refund);
      if (amount) queryParams.append("amount", amount);
      // const query = new URLSearchParams({
      //   search: search || "",
      //   export: "false",
      //   pageNo: String(pageSelected || 1),
      //   perPage: "10",
      //   ...Object.fromEntries(
      //     Object.entries(rest).filter(([_, v]) => v !== undefined && v !== "")
      //   ),
      // });

      // const res = await API.get(
      //   `${ADMIN_API_ENDPOINTS.PAYMENTS}?search=${
      //     search || ""
      //   }&export=false&pageNo=${pageSelected}&perPage=10`
      // );

      const res = await API.get(
        `${ADMIN_API_ENDPOINTS.PAYMENTS}?${queryParams.toString()}`
      );

      return {
        data: res?.data?.data?.results,
        totalRecord: res?.data?.data?.totalRecord,
      };
    } catch (error) {
      console.log("error", error);
    }
  }
);

export const handleRefundStatus = createAsyncThunk(
  "update-refund-status",
  async (payload) => {
    try {
      await API.put(ADMIN_API_ENDPOINTS.PAYMENTS_STATUS, {
        id: payload?.id,
        status: payload?.status,
        message: payload?.message,
      });
      return {
        id: payload?.id,
        status: payload?.status,
        message: payload?.message,
      };
    } catch (error) {
      console.log(error);
    }
  }
);

export const exportPayments = createAsyncThunk("export-payments", async () => {
  try {
    const res = await API.get(`${ADMIN_API_ENDPOINTS.PAYMENTS}?export=true`, {
      responseType: "blob",
    });
    return res;
  } catch (error) {
    console.log("error", error);
  }
});

const paymentSlice = createSlice({
  name: "payments",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      //-----------GET ALL PAYMENTS--------------------------
      .addCase(getAllPayments.pending, (state, action) => {
        state.isPaymentsLoading = true;
      })
      .addCase(getAllPayments.rejected, (state, action) => {
        state.isPaymentsLoading = false;
      })
      .addCase(getAllPayments.fulfilled, (state, action) => {
        state.isPaymentsLoading = false;
        state.payments = action.payload?.data;
        state.totalCount = action.payload?.totalRecord;
      })
      //------------------TOGGLE STATUS------------------------
      .addCase(handleRefundStatus.fulfilled, (state, action) => {
        const index = state.payments.findIndex(
          (row) => row.id === action.payload?.id
        );

        state.payments[index].refundStatus = action.payload?.status;
        state.payments[index].message = action.payload?.message;
      })
      //--------------------EXPORT PAYMENTS--------------------
      .addCase(exportPayments.pending, (state, action) => {
        state.isExporting = true;
      })
      .addMatcher(
        isAnyOf(exportPayments.fulfilled, exportPayments.rejected),
        (state) => {
          state.isExporting = false;
        }
      );
  },
});

export const { setFilters } = paymentSlice.actions;
export default paymentSlice.reducer;
